import {
  getLocalStorageMenuItem,
  ISDARKTHEME,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileSubTextColor,
  setMobileTextColor,
} from "../../../utility";

import no_image from "../../../images/No_Image_Available.jpg";
import {
  unstable_HistoryRouter,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import FavortieIcon from "./favoriteIcon";
import { t } from "i18next";
import { Badge } from "react-bootstrap";
import { useState } from "react";

const onImageError = (e) => {
  e.target.src = no_image;
};

const DishFullRow = ({
  item,
  qrCode,
  in_root,
  qrName,
  sympole,
  handleFavorite,
  favorites,
  suggested,
  scrollPosition,
}) => {
  const [params, setParams] = useSearchParams();
  const [treeData, setTreeData] = useState(
    getLocalStorageMenuItem("tree_data") || []
  );

  const navigate = useNavigate();
  const location = useLocation();

  const openItem = () => {
    if (item.sold_out !== 1) {
      navigate(
        `/${qrName}/${qrCode}/items?item=${item.id}&section=${params.get("section")}&t=${params.get(
          "t"
        )}&oneItem=${params.get("oneItem")}&selectedLang=${getLocalStorageMenuItem(
          "lang"
        )}`,

        {
          state: {
            itemData: item,
            sympole: sympole,
            in_root: in_root,
            from: location.pathname,
          },
        }
      );
    }
  };

  return (
    <div
      className="dishe-full-card col-md-12 mt-3 mx-auto position-relative alignByLang"
      style={{
        height: item.sold_out === 1 ? "200px" : "185px",
        backgroundColor:
          getLocalStorageMenuItem("theme") === "dark" ||
            getLocalStorageMenuItem("theme") === "light" ||
            getLocalStorageMenuItem("theme") === "costomize"
            ? setMobileCardColor()
            : "",
        borderColor:
          getLocalStorageMenuItem("theme") === "dark" ||
            getLocalStorageMenuItem("theme") === "light" ||
            getLocalStorageMenuItem("theme") === "costomize"
            ? setMobileCardBorderColor()
            : setMobileCardBorderColor(),
        borderWidth: 1,
        padding: "12px",
      }}
      onClick={openItem}
    >
      <div className="dishe-full-card-data">
        <h2
          className="item-name mb-0 cursor head-font"
          style={{
            color: setMobileTextColor(),
          }}
        >
          {item.name}
        </h2>
        <h3
          className="item-description mt-1 sub-font"
          style={{
            color: setMobileSubTextColor(),
            maxLines: 1,
          }}
        >
          {item.description}
        </h3>
        <div
          style={{
            padding: "3px",
          }}
          className=""
        >
          <Badge
            style={{
              borderRadius: "8px",
            }}
            className={`${item.sold_out === 1 ? "" : "d-none"
              } outofinstock-badge-dish-style p-2 font-size-12 sub-font m-1`}
          >
            {t("Out of stock")}
          </Badge>
        </div>


        <div
          className={`position-absolute`}
          style={
            getLocalStorageMenuItem("lang") === "ar" ||
              getLocalStorageMenuItem("lang") === "fa"
              ? {
                bottom: "12px",
                left: "12px",
              }
              : {
                bottom: "12px",
                right: "12px",
              }
          }
        >




          {item.has_price_options ? (
            <strong
              className="head-font"
              style={{
                color:
                  getLocalStorageMenuItem("theme") === "costomize"
                    ? setMobileTextColor()
                    : "#6ba5f2 ",
              }}
            >
              {item.lowest_price_option
                ? t("STARTS AT") + " " + item.lowest_price_option
                : item.price || 0}{" "}
              {sympole ? sympole === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympole : ""}
            </strong>
          ) : (
            <strong
              className="head-font"
              style={{
                color:
                  getLocalStorageMenuItem("theme") === "costomize"
                    ? setMobileTextColor()
                    : "#6ba5f2 ",
                fontSize: 20,
              }}
            >
              {item?.old_price > 0 && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "red",
                  }}
                >
                  {item.old_price || ""}
                </span>
              )}{" "}
              {item.price} {sympole ? sympole === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympole : ""}
            </strong>
          )}
        </div>
      </div>
      <div>
        <img
          className="mainImage cursor"
          src={item.image ? item.image : no_image}
          onError={onImageError}
          // onClick={openItem}
          style={{ position: "relative", height: "80%" }}
        />
        <FavortieIcon
          item={item}
          handleFavorite={handleFavorite}
          favorites={favorites}
          suggested={suggested}
        />
        {/* <div
          style={{
            padding: "6px",
          }}
          className=""
        >
          <Badge
            style={{
              borderRadius: "8px",
            }}
            className={`${item.sold_out !== 1 ? "" : "d-none"
              } outofinstock-badge-dish-style p-2 font-size-12 sub-font m-1`}
          >
            {t("Out of stock")}
          </Badge>
        </div> */}

        <div style={{
          padding: "6px",
        }}>

          {item?.warnings?.map((element) => (
            <img
              key={element.id}
              style={{
                width: "24px",
                height: "24px",
                marginInline: "8px",
              }}
              src={
                ISDARKTHEME(
                  getLocalStorageMenuItem("theme") ||
                  treeData?.details?.mobile_settings?.theme,
                  setMobileBackColor() ||
                  treeData?.details?.mobile_settings?.colorProps?.back
                )
                  ? element?.icon_dark || element.icon
                  : element?.icon_light || element.icon
              }
              onError={onImageError}
              alt="icon"
              className="mx-1"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DishFullRow;
